import * as React from 'react';
import { MessageBar, MessageBarType, PrimaryButton } from 'office-ui-fabric-react';
import { SourceType, SourceType_ } from '../../store/ExternalEpmConnectStore';
import Link from '../common/Link';
import { ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { CommonOperations, contains } from '../../store/permissions';
type Props = {
    connector: SourceType;
    permissions: CommonOperations;
    onShowContactUsDialog?: () => void;
};
const NotAllowedMessage = ({ connector, permissions, onShowContactUsDialog }: Props) => {
    if(connector === SourceType.Spo) {
        return <>
            <MessageBar
                messageBarType={MessageBarType.info}>
                <span>{SourceType_.getName(connector)} has reached its end-of-life and is no longer supported</span>
            </MessageBar>
            <div className="buttons-container">
                <PrimaryButton onClick={onShowContactUsDialog}>Contact Us</PrimaryButton>
            </div>
        </>
    }

    return <MessageBar
        messageBarType={MessageBarType.info}>{SourceType_.getName(connector)} linking is not allowed by your{contains(permissions, CommonOperations.BillingManage)
            ? <Link href="/billing">license plan</Link>
            : <span>license plan</span>}</MessageBar>
}

function mapStateToProps(state: ApplicationState) {
    return {
        permissions: state.user.permissions.common
    }
}

export default connect(mapStateToProps, {})(NotAllowedMessage);